import React, { useCallback } from "react"
import { Box, Container, useTheme } from "@mui/material"
import isNil from "lodash/isNil"

import { Header, HeaderLogo, HeaderTitle } from "components/Header"
import { Clock } from "components/Clock"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { BackIconButton } from "components/Button"
import { Footer } from "components/Footer"
import { useQuery } from "hooks"

export const PageLayout = ({
  children,
  header = null,
  footer = null,
  ...props
}) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [, resource, id] = pathname.split("/")
  const { redirectTo = `/${resource}` } = useQuery()
  const isShowBackButton = !isNil(resource) && !isNil(id)

  const handleClick = useCallback(
    () => navigate(isNaN(redirectTo) ? redirectTo : parseInt(redirectTo)),
    [navigate, redirectTo]
  )

  const theme = useTheme()
  const styleOverrides = theme.components[`AppPageLayout`]?.styleOverrides || {}
  const { root, headerBackIconContainer, container } = styleOverrides

  return (
    <Box sx={root} {...props} data-name="PageLayout">
      <Header
        logo={<HeaderLogo />}
        title={<HeaderTitle />}
        clock={<Clock />}
        backButton={
          isShowBackButton && (
            <Box sx={headerBackIconContainer}>
              <BackIconButton onClick={handleClick} />
            </Box>
          )
        }
      />
      <Container maxWidth="md" sx={container}>
        <Outlet />
      </Container>
      <Box sx={{ flexGrow: 1 }} />
      <Footer />
    </Box>
  )
}
